export const ADD_TEST_FEATURE_START = 'ADD_TEST_FEATURE_START';
export const ADD_TEST_FEATURE_SUCCESS = 'ADD_TEST_FEATURE_SUCCESS';
export const ADD_TEST_FEATURE_ERROR = 'ADD_TEST_FEATURE_ERROR';
